import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";

const word = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: 0.1 * i, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden pt-36 pb-24 sm:pt-44 sm:pb-32">
      <div className="absolute inset-0 aes-grid-bg [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
      <motion.div
        aria-hidden
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 0.5, scale: 1 }}
        transition={{ duration: 1.4, ease: "easeOut" }}
        className="absolute -top-32 right-[-10%] h-[480px] w-[480px] rounded-full blur-3xl aes-gradient opacity-10 pointer-events-none"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          custom={0}
          variants={word}
          initial="hidden"
          animate="show"
          className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/60 backdrop-blur px-4 py-1.5 text-xs font-medium text-[#52525B] mb-8"
        >
          <span className="h-1.5 w-1.5 rounded-full aes-gradient" />
          Web design studio · Available for new projects
        </motion.div>

        <h1 className="font-display font-light tracking-tight text-[#0A0A0A] text-5xl sm:text-6xl lg:text-7xl leading-[1.02] max-w-4xl">
          <motion.span custom={1} variants={word} initial="hidden" animate="show" className="block">
            Sites That <span className="aes-gradient-text font-medium">Convert</span>
          </motion.span>
          <motion.span custom={2} variants={word} initial="hidden" animate="show" className="block">
            Designs That Endure
          </motion.span>
        </h1>

        <motion.p
          custom={3}
          variants={word}
          initial="hidden"
          animate="show"
          className="mt-8 max-w-xl text-lg text-[#52525B] leading-relaxed"
        >
          We design and build standout websites for ambitious brands — minimal, fast, and
          engineered to turn visitors into customers. See a free demo before you commit.
        </motion.p>

        <motion.div
          custom={4}
          variants={word}
          initial="hidden"
          animate="show"
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <a
            href="#contact"
            data-testid="hero-primary-cta"
            className="group aes-gradient text-white font-medium px-7 py-3.5 rounded-full inline-flex items-center gap-2 hover:opacity-90 transition-opacity"
          >
            Start your project
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#work"
            data-testid="hero-secondary-cta"
            className="group text-[#0A0A0A] font-medium px-7 py-3.5 rounded-full border border-black/10 inline-flex items-center gap-2 hover:bg-black/[0.03] transition-colors"
          >
            View our work
            <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
